//TODO: get list from County table
export class County {
    public static values = [
        "AITKIN",
        "ANOKA",
        "BECKER",
        "BELTRAMI",
        "BENTON",
        "BIG STONE",
        "BLUE EARTH",
        "BROWN",
        "CARLTON",
        "CARVER",
        "CASS",
        "CHIPPEWA",
        "CHISAGO",
        "CLAY",
        "CLEARWATER",
        "COOK",
        "COTTONWOOD",
        "CROW WING",
        "DAKOTA",
        "DODGE",
        "DOUGLAS",
        "FARIBAULT",
        "FILLMORE",
        "FREEBORN",
        "GOODHUE",
        "GRANT",
        "HENNEPIN",
        "HOUSTON",
        "HUBBARD",
        "ISANTI",
        "ITASCA",
        "JACKSON",
        "KANABEC",
        "KANDIYOHI",
        "KITTSON",
        "KOOCHICHING",
        "LAC QUI PARLE",
        "LAKE OF THE WOODS",
        "LAKE",
        "LESUEUR",
        "LINCOLN",
        "LYON",
        "MAHNOMEN",
        "MARSHALL",
        "MARTIN",
        "MCLEOD",
        "MEEKER",
        "MILLE LACS",
        "MORRISON",
        "MOWER",
        "MURRAY",
        "NICOLLET",
        "NOBLES",
        "NORMAN",
        "OLMSTED",
        "OTTER TAIL",
        "PENNINGTON",
        "PINE",
        "PIPESTONE",
        "POLK",
        "POPE",
        "RAMSEY",
        "RED LAKE",
        "REDWOOD",
        "RENVILLE",
        "RICE",
        "ROCK",
        "ROSEAU",
        "SAINT LOUIS",
        "SCOTT",
        "SHERBURNE",
        "SIBLEY",
        "STEARNS",
        "STEELE",
        "STEVENS",
        "SWIFT",
        "TODD",
        "TRAVERSE",
        "WABASHA",
        "WADENA",
        "WASECA",
        "WASHINGTON",
        "WATONWAN",
        "WILKIN",
        "WINONA",
        "WRIGHT",
        "YELLOW MEDICINE"
    ]
}